module.exports = ":host {\n  display: block;\n  height: auto; }\n  @media (min-width: 960px) {\n    :host {\n      height: 100%; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main